import {NgModule} from '@angular/core';
import {MaterialModule} from '../material/material.module';
import {ConfirmationDialogComponent} from './components/confirmation-dialog/confirmation-dialog.component';
import {FroalaEditorModule, FroalaViewModule} from 'angular-froala-wysiwyg';
import {FieldGroupRendererComponent} from './components/field-group-renderer/field-group-renderer.component';
import {FlightEditorComponent} from './components/flight-edit/flight-edit.component';
import {FieldGroupsRendererComponent} from './components/field-groups-renderer/field-groups-renderer.component';
import {TabReviewComponent} from './components/tab-review/tab-review.component';
import {AdHocServicesOverviewComponent} from './components/ad-hoc-services-overview/ad-hoc-services-overview.component';
import {CommentsComponent} from './components/comments/comments.component';
import {HistoryComponent} from './components/history/history.component';
import {ComplimentComponent} from './components/compliment/compliment.component';
import {ComplaintComponent} from './components/complaint/complaint.component';
import {FeedbackComponent} from './components/feedback/feedback.component';
import {FlightFieldGroupService} from './services/flight-field-group/flight-field-group.service';
import {ComplaintService} from './services/feedback/complaint.service';
import {ComplimentService} from './services/feedback/compliment.service';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {UtilitiesModule} from '../utilities/utilities.module';
import {FieldsModule} from '../fields/fields.module';

import { FlightCacheService } from './services/flight-cache/flight-cache.service';
import {ArrivalDepartureServicesComponent} from './components/arrival-departure-services/arrival-departure-services.component';
import { ActivityComponent } from './components/activity/activity.component';

@NgModule({
  declarations: [
    ConfirmationDialogComponent,
    FieldGroupRendererComponent,
    FlightEditorComponent,
    FieldGroupsRendererComponent,
    TabReviewComponent,
    AdHocServicesOverviewComponent,
    CommentsComponent,
    HistoryComponent,
    ComplimentComponent,
    ComplaintComponent,
    FeedbackComponent,
    ArrivalDepartureServicesComponent,
    ActivityComponent
  ],
  entryComponents: [
    ConfirmationDialogComponent
  ],
  imports: [
    MaterialModule,
    CommonModule,
    FormsModule,
    UtilitiesModule,
    RouterModule,
    FieldsModule,
    ReactiveFormsModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot()
  ],
  exports: [
    FieldGroupRendererComponent,
    FlightEditorComponent,
    FieldGroupsRendererComponent,
  ],
  providers: [
    FlightFieldGroupService,
    ComplaintService,
    ComplimentService,
    FlightCacheService
  ]
})
export class FormRendererModule { }



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-renderer/form-renderer.module.ts